import { createStore } from 'satcheljs';
export default createStore('forwardingConfiguration', {
    mailboxForwardingConfiguration: null,
})();
//# sourceMappingURL=store.js.map